import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppInitService } from '../../services/app-init.service';
import { StyleManagerService } from '../../services/theme-manager.service';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  step = 0;

  setStep(index: number) {
    this.step = index;
  }
  selectedTheme: any;
  private readonly stylesBasePath = `./assets/themes/`;
  otherTheme: boolean = false;

  lang: any;
  locale: string;
  langList: any[];
  currentLang: any;
  thm: string;
  currentTheme: any[];
  themeList: string[];
  localeList: any;
  localeValue: any;
  shortDateList = [];
  selectedDepartment;
  longDateList = [];
  myform: FormGroup;
  dateFormatList = [];
  timeFormatList = [];
  shortTimeList = [];
  longTimeList = [];
  medDateList = [];
  fullDateList = [];
  medTimeList = [];
  fullTimeList = [];
  dtFormatList = [];
  shortDtList = [];
  longDtList = [];
  medDtList = [];
  fullDtList = [];
  constructor(
    public translate: TranslateService,
    public appInitService: AppInitService,
    private readonly styleManager: StyleManagerService,
    public http: HttpClient
  ) {
    if (localStorage.getItem('appLanguage')) {
      this.lang = localStorage.getItem('appLanguage');
    } else {
      this.lang = this.appInitService.language;
    }
    this.locale = this.appInitService.locale;
    this.langList = this.appInitService._langList;
    this.langList.forEach((lang) => {
      if (this.lang === lang?.langCode) {
        this.currentLang = lang;
      }
    });
    this.themeList = this.appInitService._themeList;
    this.selectedTheme = this.appInitService.currentTheme;
  }

  ngOnInit(): void {
    console.log();
    this.themeList = this.appInitService._themeList;
    this.selectedTheme = this.appInitService.currentTheme;
    this.selectedTheme = this.appInitService.currentTheme;
    this.myform = new FormGroup({
      dateInput: new FormControl(),
      amount: new FormControl(),
      percentInput: new FormControl(),
      selectedShortDate: new FormControl(),
      selectedLongDate: new FormControl(),
      selectedDateFormat: new FormControl(),
      selectedTimeFormat: new FormControl(),
      selectedShortTime: new FormControl(),
      selectedLongTime: new FormControl(),
      selectedMedDate: new FormControl(),
      selectedFullDate: new FormControl(),
      selectedMedTime: new FormControl(),
      selectedFullTime: new FormControl(),
      selectedFullDt: new FormControl(),
      selectedMedDt: new FormControl(),
      selectedLongDt: new FormControl(),
      selectedShortDt: new FormControl(),
      selectedDtFormat: new FormControl(),
      selectedLocale: new FormControl(),
    });
    this.populateShortDate();
    this.populateLongDate();
    this.populateDateFormat();
    this.populateTimeFormat();
    this.populateLongTime();
    this.populateShortTime();
    this.populateMedDate();
    this.populateFullDate();
    this.populateMedTime();
    this.populateFullTime();
    this.populateDtFormat();
    this.populateShortDt();
    this.populateMedDt();
    this.populateLongDt();
    this.populateFullDt();
    this.fetchLocales();
  }

fetchLocales() {
  const dataForPost = {
    ComboId: '2615',
  };
  this.http.get('/admin/language-details').subscribe((res: any) => {
    console.log('*********Locales List', res);
    res?.data.forEach((loc) => {
      loc['displayName'] = loc?.langName + ' (' + loc.countryCode + ')';
    });
    this.localeList = res?.data;
    this.localeList?.forEach((locale) => {
      if (locale.locale == this.appInitService.locale.locale) {
        this.localeValue = locale;
      }
    });
  });
}
populateShortDate() {
  const dataForPost = {
    ComboId: '2600',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Short Date List', res);
      this.shortDateList = res?.data;
      this.shortDateList?.forEach((sDate) => {
        if (sDate.optionDesc == this.appInitService.locale.shortDateFormat) {
          this.myform.controls['selectedShortDate'].setValue(sDate);
        }
      });
    });
}
populateLongDate() {
  const dataForPost = {
    ComboId: '2601',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Long Date List', res);
      this.longDateList = res.data;
      this.longDateList?.forEach((lDate) => {
        if (lDate.optionDesc == this.appInitService.locale.longDateFormat) {
          this.myform.controls['selectedLongDate'].setValue(lDate);
        }
      });
    });
}
populateMedDate() {
  const dataForPost = {
    ComboId: '2603',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Full Date List', res);
      this.medDateList = res.data;
      this.medDateList?.forEach((mDate) => {
        if (mDate.optionDesc == this.appInitService.locale.mediumDateFormat) {
          this.myform.controls['selectedMedDate'].setValue(mDate);
        }
      });
    });
}
populateFullDate() {
  const dataForPost = {
    ComboId: '2602',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Full Date List', res);
      this.fullDateList = res.data;
      this.fullDateList?.forEach((fDate) => {
        if (fDate.optionDesc == this.appInitService.locale.fullDateFormat) {
          this.myform.controls['selectedFullDate'].setValue(fDate);
        }
      });
    });
}
populateDateFormat() {
  const dataForPost = {
    ComboId: '2604',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Date Format List', res);
      this.dateFormatList = res.data;
      this.dateFormatList?.forEach((fDate) => {
        if (fDate.optionDesc == this.appInitService.locale.dateFormat) {
          this.myform.controls['selectedDateFormat'].setValue(fDate);
        }
      });
    });
}
populateShortDt() {
  const dataForPost = {
    ComboId: '2611',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Short DateTime List', res);
      this.shortDtList = res.data;
      this.shortDtList?.forEach((sDt) => {
        if (sDt.optionDesc == this.appInitService.locale.shortDateTimeFormat) {
          this.myform.controls['selectedShortDt'].setValue(sDt);
        }
      });
    });
}
populateLongDt() {
  const dataForPost = {
    ComboId: '2612',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Long DateTime List', res);
      this.longDtList = res.data;
      this.longDtList?.forEach((lDt) => {
        if (lDt.optionDesc == this.appInitService.locale.longDateTimeFormat) {
          this.myform.controls['selectedLongDt'].setValue(lDt);
        }
      });
    });
}
populateMedDt() {
  const dataForPost = {
    ComboId: '2614',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Med DateTime List', res);
      this.medDtList = res.data;
      this.medDtList?.forEach((mDt) => {
        if (mDt.optionDesc == this.appInitService.locale.mediumDateTimeFormat) {
          this.myform.controls['selectedMedDt'].setValue(mDt);
        }
      });
    });
}
populateFullDt() {
  const dataForPost = {
    ComboId: '2613',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Full Date Time List', res);
      this.fullDtList = res.data;
      this.fullDtList?.forEach((fDt) => {
        if (fDt.optionDesc == this.appInitService.locale.fullDateTimeFormat) {
          this.myform.controls['selectedFullDt'].setValue(fDt);
        }
      });
    });
}
populateDtFormat() {
  const dataForPost = {
    ComboId: '2610',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********DateTime Format List', res);
      this.dtFormatList = res.data;
      this.dtFormatList?.forEach((fDt) => {
        if (fDt.optionDesc == this.appInitService.locale.dateTimeFormat) {
          this.myform.controls['selectedDtFormat'].setValue(fDt);
        }
      });
    });
}
populateTimeFormat() {
  const dataForPost = {
    ComboId: '2605',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Time Format List', res);
      this.timeFormatList = res.data;
      this.timeFormatList?.forEach((fTime) => {
        if (fTime.optionDesc == this.appInitService.locale.timeFormat) {
          this.myform.controls['selectedTimeFormat'].setValue(fTime);
        }
      });
    });
}
populateShortTime() {
  const dataForPost = {
    ComboId: '2606',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Short Time Format List', res);
      this.shortTimeList = res.data;
      this.shortTimeList?.forEach((sTime) => {
        if (sTime.optionDesc == this.appInitService.locale.shortTimeFormat) {
          this.myform.controls['selectedShortTime'].setValue(sTime);
        }
      });
    });
}
populateLongTime() {
  const dataForPost = {
    ComboId: '2607',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Short Time Format List', res);
      this.longTimeList = res.data;
      this.longTimeList?.forEach((lTime) => {
        if (lTime.optionDesc == this.appInitService.locale.longTimeFormat) {
          this.myform.controls['selectedLongTime'].setValue(lTime);
        }
      });
    });
}
populateMedTime() {
  const dataForPost = {
    ComboId: '2608',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Medium Time Format List', res);
      this.medTimeList = res.data;
      this.medTimeList?.forEach((mTime) => {
        if (mTime.optionDesc == this.appInitService.locale.mediumTimeFormat) {
          this.myform.controls['selectedMedTime'].setValue(mTime);
        }
      });
    });
}
populateFullTime() {
  const dataForPost = {
    ComboId: '2609',
  };
  this.http
    .post('/worklist/get-combo-list', dataForPost)
    .subscribe((res: any) => {
      console.log('*********Full Time Format List', res);
      this.fullTimeList = res.data;
      this.fullTimeList?.forEach((fTime) => {
        if (fTime.optionDesc == this.appInitService.locale.fullTimeFormat) {
          this.myform.controls['selectedFullTime'].setValue(fTime);
        }
      });
    });
}
  themeChangeHandler(themeToSet: any) {
    this.selectedTheme = themeToSet;
    console.log(themeToSet);
    // this.styleManager.setStyle(`${this.stylesBasePath}${themeToSet.value}.css`);
    this.appInitService.currentTheme = themeToSet;
    localStorage.setItem('selected-theme', JSON.stringify(themeToSet));
  }


  onSave(): void {
    /* const postData = {
      langId: this.currentLang?.langId,
    }; */
    const postData = {
      langId: this.localeValue?.langId,
    };
    /* const dataForPost2 = {
      preferences: {
        langId: this.currentLang?.langId,
      },
    };
    this.http
      .post('/core/save-user-preferences', dataForPost2)
      .subscribe((resData) => {
        this.http
          .post('/admin/save-language-details', postData)
          .subscribe((res) => {
            console.log(res);
            this.appInitService.switchLanguage(this.currentLang);
          });
        this.translate.use(this.lang);
      }); */
    let selectedLang = this.localeValue?.locale.split('_')[0];
    this.lang = selectedLang;
    this.appInitService._lang = this.lang;
    this.translate.use(this.lang);
    const dataForPost = {
      preferences: {
        dateFormat: this.myform.get('selectedDateFormat').value.optionDesc,
        shortDateFormat: this.myform.get('selectedShortDate').value.optionDesc,
        longDateFormat: this.myform.get('selectedLongDate').value.optionDesc,
        mediumDateFormat: this.myform.get('selectedMedDate').value.optionDesc,
        fullDateFormat: this.myform.get('selectedFullDate').value.optionDesc,
        timeFormat: this.myform.get('selectedTimeFormat').value.optionDesc,
        shortTimeFormat: this.myform.get('selectedShortTime').value.optionDesc,
        longTimeFormat: this.myform.get('selectedLongTime').value.optionDesc,
        mediumTimeFormat: this.myform.get('selectedMedTime').value.optionDesc,
        fullTimeFormat: this.myform.get('selectedFullTime').value.optionDesc,
        dateTimeFormat: this.myform.get('selectedDtFormat').value.optionDesc,
        shortDateTimeFormat: this.myform.get('selectedShortDt').value
          .optionDesc,
        longDateTimeFormat: this.myform.get('selectedLongDt').value.optionDesc,
        mediumDateTimeFormat: this.myform.get('selectedMedDt').value.optionDesc,
        fullDateTimeFormat: this.myform.get('selectedFullDt').value.optionDesc,
        local: this.localeValue.locale,
        currency: this.localeValue.currency,
        theme: this.selectedTheme.id,
        langId: this.localeValue?.langId,
      },
    };
    this.http.post('/core/save-user-preferences', dataForPost).subscribe(() => {
      this.http
        .post('/admin/save-language-details', postData)
        .subscribe((res) => {
          let locale = this.appInitService.locale;
          locale.dateFormat = this.myform.get(
            'selectedDateFormat'
          ).value.optionDesc;
          locale.timeFormat = this.myform.get(
            'selectedTimeFormat'
          ).value.optionDesc;
          locale.shortDateFormat = this.myform.get(
            'selectedShortDate'
          ).value.optionDesc;
          locale.longDateFormat = this.myform.get(
            'selectedLongDate'
          ).value.optionDesc;
          locale.mediumDateFormat = this.myform.get(
            'selectedMedDate'
          ).value.optionDesc;
          locale.fullDateFormat = this.myform.get(
            'selectedFullDate'
          ).value.optionDesc;
          locale.shortTimeFormat = this.myform.get(
            'selectedShortTime'
          ).value.optionDesc;
          locale.longTimeFormat = this.myform.get(
            'selectedLongTime'
          ).value.optionDesc;
          locale.mediumTimeFormat = this.myform.get(
            'selectedMedTime'
          ).value.optionDesc;
          locale.fullTimeFormat = this.myform.get(
            'selectedFullTime'
          ).value.optionDesc;
          locale.dateTimeFormat = this.myform.get(
            'selectedDtFormat'
          ).value.optionDesc;
          locale.shortDateTimeFormat = this.myform.get(
            'selectedShortDt'
          ).value.optionDesc;
          locale.longDateTimeFormat = this.myform.get(
            'selectedLongDt'
          ).value.optionDesc;
          locale.mediumDateTimeFormat = this.myform.get(
            'selectedMedDt'
          ).value.optionDesc;
          locale.fullDateTimeFormat = this.myform.get(
            'selectedFullDt'
          ).value.optionDesc;
          locale.locale = this.localeValue?.locale;
          locale.currency = this.localeValue?.currency;
          locale.theme = this.selectedTheme.id;
          this.appInitService.currentTheme = this.selectedTheme;
          // locale.currencyValue = this.localeValue?.currency;
          this.appInitService.switchLocaleLazyLoad(locale, this.localeValue);
        });
    });
  }

  switchLocale = (locale: string): void =>
    this.appInitService.switchLocaleLazyLoad(locale, this.localeValue);
}
